var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.avatar, _vm.size]},[(_vm.src)?_c('img',{style:({ width: 'inherit', height: 'inherit' }),attrs:{"src":_vm.src}}):_c('img')])}
var staticRenderFns = []

export { render, staticRenderFns }